<template>
  <div class="drawing-container">
    <el-container>
      <!-- 左侧导航栏 -->
      <el-aside width="279px" class="diagram-aside">
        <el-menu :default-active="activeNav" class="sidebar-menu" background-color="#eaf6fe" text-color="#222" active-text-color="#2EA2FA" :unique-opened="true">
          <el-submenu index="1" :popper-append-to-body="false">
            <template #title>
              <div class="sidebar-title-row">
                <img src="/image/menu-drawing.png" class="sidebar-svg-icon" alt="课堂制图" />
                <span class="sidebar-title">课堂制图</span>
              </div>
            </template>
            <el-menu-item index="1-1" @click="selectNav('drawing')">
              <div class="sidebar-title-row">
                <img :src="activeNav==='1-1' ? '/image/video-icon-active.png' : '/image/video-icon.png'" class="sidebar-svg-icon" alt="制作" />
                <span>制作</span>
              </div>
            </el-menu-item>
          </el-submenu>
          <el-submenu index="2" :popper-append-to-body="false">
            <template #title>
              <div class="sidebar-title-row">
                <img src="/image/iconsvideo-icon-active.png" class="sidebar-svg-icon" alt="参数列表" />
                <span class="sidebar-title">参数列表</span>
              </div>
            </template>
            <el-menu-item 
              v-for="item in materialParams" 
              :key="item.id"
              :index="item.id"
              @click="selectNav('parameters', item)"
            >
              <div class="sidebar-title-row">
                <img :src="activeNav===String(item.id) ? '/image/video-icon-active.png' : '/image/video-icon.png'" class="sidebar-svg-icon" alt="参数" />
                <span>{{ item.name }}</span>
              </div>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>

      <!-- 右侧内容区域 -->
      <el-main>
        <div v-if="selectedNav === 'drawing'" class="drawing-content">
          <!-- 添加搜索框 -->
          <div class="search-container">
            <el-input
              v-model="searchQuery"
              placeholder="请输入作业名称搜索"
              style="width: 300px;"
              clearable
              @clear="handleClear"
              @keyup.enter.native="handleSearch"
            >
              <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
            </el-input>
            
            <!-- 添加高级搜索选项 -->
            <!-- <el-select 
              v-model="searchType" 
              placeholder="搜索类型" 
              style="margin-left: 10px; width: 120px;"
            >
              <el-option label="作业名称" value="homeworkName"></el-option>
              <el-option label="课程名称" value="courseName"></el-option>
              <el-option label="发布老师" value="teachName"></el-option>
            </el-select> -->
            
            <!-- 添加时间范围筛选 -->
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="margin-left: 10px; width: 320px;"
              value-format="yyyy-MM-dd"
              @change="handleDateChange"
            >
            </el-date-picker>
          </div>

          <!-- 卡片宫格布局 -->
          <div class="diagram-card-grid">
            <div v-for="item in drawingData" :key="item.id" class="diagram-card">
              <div class="diagram-id">ID: {{ item.id }}</div>
              <div class="diagram-card-main">
                <img :src="item.url" alt="预览图" class="diagram-img" />
                <div class="diagram-info">
                  <div class="diagram-title">作业名称：{{ item.homeworkName }}</div>
                  <div class="diagram-meta">
                    <span>课程名称：</span>
                    <el-button type="text" @click="goToCourse(item)" class="diagram-link">{{ item.courseName }}</el-button>
                  </div>
                  <div class="diagram-meta">发布老师：{{ item.teachName }}</div>
                  <div class="diagram-meta">发布时间：{{ formatDateTime(item.updateTime) }}</div>
                </div>
              </div>
              <div class="diagram-card-footer">
                <el-button type="primary" size="medium" class="diagram-make-btn" @click="selectNav('drawing'); makeDrawing(item)">制作</el-button>
              </div>
            </div>
            <div v-if="drawingData.length === 0" class="empty-tip">暂无作业</div>
          </div>
          <div class="pagination-container">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>

        <div v-else-if="selectedNav === 'parameters' && currentMaterial" class="parameters-content">
          <div class="material-detail">
            <!-- 材质标题和描述 -->
            <div class="material-header">
              <h2>{{ currentMaterial.name }}</h2>
              <p class="material-description">{{ currentMaterial.description }}</p>
            </div>

            <!-- 材质概述 -->
            <div class="material-overview">
              <el-row :gutter="24">
                <el-col :span="8">
                  <div class="material-image">
                    <img :src="currentMaterial.image" :alt="currentMaterial.name">
                  </div>
                </el-col>
                <el-col :span="16">
                  <div class="material-info">
                    <div class="info-section">
                      <h3><i class="el-icon-info"></i> 材质特性</h3>
                      <ul class="feature-list">
                        <li v-for="(feature, index) in currentMaterial.features" 
                            :key="index">{{ feature }}</li>
                      </ul>
                    </div>
                    <div class="info-section">
                      <h3><i class="el-icon-warning-outline"></i> 使用建议</h3>
                      <p class="tips-text">{{ currentMaterial.tips }}</p>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>

            <!-- 参数表格 -->
            <div class="parameters-section">
              <h3><i class="el-icon-setting"></i> 推荐参数</h3>
              <el-table :data="currentMaterial.parameters" border stripe>
                <el-table-column prop="name" label="参数名称" width="150" align="center">
                  <template #default="scope">
                    <div class="param-name">
                      <i :class="scope.row.icon"></i>
                      <span>{{ scope.row.name }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="value" label="推荐值" width="120" align="center">
                  <template #default="scope">
                    <el-tag size="medium" type="success">{{ scope.row.value }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="range" label="可调范围" width="150" align="center">
                  <template #default="scope">
                    <el-tag size="medium" type="info">{{ scope.row.range }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="description" label="参数说明"></el-table-column>
              </el-table>
            </div>

            <!-- 效果示例 -->
            <div class="examples-section">
              <h3><i class="el-icon-picture-outline"></i> 效果示例</h3>
              <el-row :gutter="20">
                <el-col 
                  v-for="(example, index) in currentMaterial.examples" 
                  :key="index"
                  :xs="24"
                  :sm="12"
                  :md="8"
                  :lg="6"
                >
                  <el-card shadow="hover" class="example-card">
                    <img :src="example.image" class="example-image">
                    <div class="example-info">
                      <h4>{{ example.title }}</h4>
                      <p>{{ example.description }}</p>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>

        <div v-else-if="selectedNav === 'parameters' && !currentMaterial" class="no-data">
          <el-empty description="请选择材质查看参数"></el-empty>
        </div>
      </el-main>

    </el-container>
  </div>
</template>

<script>
import axios from 'axios';
import { EventBus } from '../event-bus';

export default {
  name: 'DrawingComponent',
  data() {
    return {
      activeNav: '1-1', // 当前活动导航项
      selectedNav: 'drawing', // 当前选中的导航
      currentMaterial: null, // 当前选中的材质
      drawingData: [], // 将从API获取数据
      isDialogVisible: false, // 控制提示框显示
      searchQuery: '', // 搜索关键词
      searchType: 'homeworkName', // 默认搜索作业名称
      dateRange: [], // 时间范围
      searchHistory: [], // 搜索历史
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示条数
      total: 0, // 总条数
      loading: false,
      emptyText: '暂无数据',
      originalData: [], // 存储原始数据
      materialParams: [
        
        {
          id: '2-2',
          name: '椴木板',
          image: '/image/dmb.jpg',
          description: '椴木板激光切割工艺指南',
          features: [
            '适合雕刻和切割',
            '切割边缘整齐',
            '厚度均匀，易于加工'
          ],
          tips: '建议先做小样测试，逐步调整功率和速度参数。',
          parameters: [
            {
              name: '功率设置',
              icon: '/static/icons/menu-param-item.svg',
              value: '70%',
              range: '50-90%',
              description: '根据木板厚度调整，厚度每增加1mm，建议功率增加15%'
            },
            {
              name: '速度设置',
              icon: '/static/icons/menu-param-item.svg',
              value: '250mm/s',
              range: '150-350mm/s',
              description: '速度越慢切割越深，建议与功率配合调整'
            },
            {
              name: '频率设置',
              icon: '/static/icons/menu-param-item.svg',
              value: '900Hz',
              range: '700-1100Hz',
              description: '影响切割精度，频率越高边缘越光滑'
            }
          ],
          examples: [
            {
              title: '雕刻效果',
              image: '/image/dmb1.jpg',
              description: '展示椴木板雕刻效果'
            },
            {
              title: '切割效果',
              image: '/image/dmb2.jpg',
              description: '椴木板切割后的边缘展示'
            }
          ]
        },
        {
          id: '2-3',
          name: '亚克力',
          image: '/image/ykl.jpg',
          description: '亚克力激光切割工艺指南',
          features: [
            '高透明度',
            '切割边缘光滑',
            '适合复杂图形切割'
          ],
          tips: '切割时建议使用较高频率，防止边缘发黄。',
          parameters: [
            {
              name: '功率设置',
              icon: '/static/icons/menu-param-item.svg',
              value: '65%',
              range: '45-85%',
              description: '根据亚克力厚度调整，厚度每增加1mm，建议功率增加12%'
            },
            {
              name: '速度设置',
              icon: '/static/icons/menu-param-item.svg',
              value: '220mm/s',
              range: '120-300mm/s',
              description: '速度越慢切割越深，建议与功率配合调整'
            },
            {
              name: '频率设置',
              icon: '/static/icons/menu-param-item.svg',
              value: '1100Hz',
              range: '900-1300Hz',
              description: '高频率可获得更光滑的切割边缘'
            }
          ],
          examples: [
            {
              title: '透明切割',
              image: '/image/ykl1.jpg',
              description: '亚克力透明边缘切割效果'
            },
            {
              title: '复杂图形',
              image: '/image/ykl2.jpg',
              description: '亚克力复杂图形切割展示'
            }
          ]
        },
        {
          id: '2-4',
          name: '纸张',
          image: '/image/zz.jpg',
          description: '纸张激光切割工艺指南',
          features: [
            '适合精细雕刻',
            '切割速度快',
            '适合制作复杂纸艺品'
          ],
          tips: '建议低功率高速度切割，避免纸张烧焦。',
          parameters: [
            {
              name: '功率设置',
              icon: '/static/icons/menu-param-item.svg',
              value: '30%',
              range: '15-50%',
              description: '纸张较薄，功率设置不宜过高'
            },
            {
              name: '速度设置',
              icon: '/static/icons/menu-param-item.svg',
              value: '400mm/s',
              range: '300-500mm/s',
              description: '速度越快越不易烧焦'
            },
            {
              name: '频率设置',
              icon: '/static/icons/menu-param-item.svg',
              value: '800Hz',
              range: '600-1000Hz',
              description: '适中频率可获得较好切割边缘'
            }
          ],
          examples: [
            {
              title: '纸雕工艺',
              image: '/image/zz1.jpg',
              description: '纸张雕刻工艺展示'
            },
            {
              title: '纸艺品制作',
              image: '/image/zz2.jpg',
              description: '纸张切割后制作的纸艺品展示'
            }
          ]
        },
        {
          id: '2-1',
          name: '皮革',
          image: '/image/pg.jpg',
          description: '皮革材质激光切割工艺指南',
          features: [
            '适合精细切割和雕刻',
            '边缘光滑，不易变形',
            '可调节功率实现不同切割深度',
            '适合多层切割工艺'
          ],
          tips: '建议从低功率开始测试，逐步调整至最佳参数。切割前确保材料平整，避免褶皱。',
          parameters: [
            {
              name: '功率设置',
              icon: '/static/icons/menu-param-item.svg',
              value: '60%',
              range: '40-80%',
              description: '根据皮革厚度调整，厚度每增加0.5mm，建议功率增加10%'
            },
            {
              name: '速度设置',
              icon: '/static/icons/menu-param-item.svg',
              value: '300mm/s',
              range: '200-400mm/s',
              description: '速度越慢切割越深，建议与功率配合调整'
            },
            {
              name: '频率设置',
              icon: '/static/icons/menu-param-item.svg',
              value: '1000Hz',
              range: '800-1200Hz',
              description: '影响切割精度，频率越高边缘越光滑'
            }
          ],
          examples: [
            {
              title: '精细雕刻',
              image: '/image/pg.jpg',
              description: '展示皮革表面精细雕刻效果'
            },
            {
              title: '穿透切割',
              image: '/image/pg.jpg',
              description: '完整切透效果展示'
            }
          ]
        },
      ],
    };
  },
  mounted() {
    window.addEventListener('blur', this.onBlur);
  },
  beforeDestroy() {
    window.removeEventListener('blur', this.onBlur);
  },
  methods: {
    selectNav(navType, material = null) {
      this.selectedNav = navType;
      if (navType === 'parameters' && material) {
        this.currentMaterial = material;
        this.activeNav = String(material.id); // 切换参数菜单时，activeNav要变
      } else if (navType === 'drawing') {
        this.activeNav = '1-1'; // 切换到“制作”时，activeNav要变
      }
    },
    // eslint-disable-next-line no-unused-vars
    makeDrawing(row) {
      this.loadingInstance = this.$loading({
        lock: true,
        text: '正在启动 GoodLaser 软件，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });

      // 启动 GoodLaser 软件
      window.location.href = 'GoodLaser://';

      // 7 秒后关闭 Loading
      setTimeout(() => {
        this.loadingInstance.close();
      }, 7000);
    },
    // 添加格式化日期时间的方法
    formatDateTime(dateArray) {
      if (!dateArray) return '';
      return `${dateArray[0]}-${String(dateArray[1]).padStart(2, '0')}-${String(dateArray[2]).padStart(2, '0')} ${String(dateArray[3]).padStart(2, '0')}:${String(dateArray[4]).padStart(2, '0')}`;
    },
    // 搜索方法
    handleSearch() {
      // console.log('执行搜索:', {
      //   type: this.searchType,
      //   query: this.searchQuery,
      //   dateRange: this.dateRange
      // });

      if (!this.searchQuery.trim() && !this.dateRange.length) {
        this.drawingData = [...this.originalData];
        return;
      }

      // 搜索关键词
      let filteredData = [...this.originalData];
      const searchTerm = this.searchQuery.trim().toLowerCase();

      if (searchTerm) {
        filteredData = filteredData.filter(item => {
          switch (this.searchType) {
            case 'homeworkName':
              return item.homeworkName.toLowerCase().includes(searchTerm);
            case 'courseName':
              return item.courseName.toLowerCase().includes(searchTerm);
            case 'teachName':
              return item.teachName.toLowerCase().includes(searchTerm);
            default:
              return true;
          }
        });
      }

      // 日期范围过滤
      if (this.dateRange && this.dateRange.length === 2) {
        const startDate = new Date(this.dateRange[0]);
        const endDate = new Date(this.dateRange[1]);
        
        filteredData = filteredData.filter(item => {
          const itemDate = new Date(item.updateTime);
          return itemDate >= startDate && itemDate <= endDate;
        });
      }

      // 更新显示数据和总数
      this.drawingData = filteredData;
      this.total = filteredData.length;

      // 处理空结果
      if (filteredData.length === 0) {
        this.emptyText = `未找到包含 "${this.searchQuery}" 的${this.getSearchTypeLabel()}`;
        this.$message.warning(this.emptyText);
      }
    },
    
    // 添加到搜索历史
    addToSearchHistory(query) {
      if (!this.searchHistory.includes(query)) {
        this.searchHistory.unshift(query);
        if (this.searchHistory.length > 5) {
          this.searchHistory.pop();
        }
      }
    },
    
    // 清空搜索
    handleClear() {
      this.searchQuery = '';
      this.dateRange = [];
      this.emptyText = '暂无数据';
      this.drawingData = [...this.originalData];
      this.total = this.originalData.length;
    },
    
    // 处理日期变化
    handleDateChange() {
      this.handleSearch();
    },
    
    // 每页条数改变
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchDrawingData();
    },

    // 页码改变
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchDrawingData();
    },

    // 修改获取数据的方法，保存原始数据
    async fetchDrawingData() {
      this.loading = true;
      try {
        const accountNumber = localStorage.getItem('userInfo');
        
        if (!accountNumber) {
          this.$message.error('未找到用户信息，请重新登录');
          return;
        }
        
        const cleanAccountNumber = accountNumber.replace(/^"|"$/g, '');
        
        // 获取用户信息
        const { data: userData } = await axios.get(
          `/api/auth/selectByAccountNumber?accountNumber=${cleanAccountNumber}`
        );
        
        // 获取作业数据
        const response = await axios.get('/api/assignHomework/all', {
          params: {
            teacherId: userData.data.teacherId,
            page: this.currentPage - 1,
            size: this.pageSize,
          }
        });
        
        if (response.data && response.data.data) {
          const content = response.data.data.content || response.data.data;
          if (Array.isArray(content)) {
            // 保存处理后的原始数据
            this.originalData = content.map(item => ({
              ...item,
              url: `/resources/assignHomework/${item.url}`,
              teachName: `${item.teachName}老师`,
              courseId: item.courseId
            }));
            
            // 如果有搜索条件，立即执行搜索
            if (this.searchQuery.trim()) {
              this.handleSearch();
            } else {
              this.drawingData = [...this.originalData];
            }
            
            this.total = response.data.data.totalElements || content.length;
          } else {
            this.handleEmptyResult();
          }
        } else {
          this.handleEmptyResult();
        }
      } catch (error) {
        console.error('获取数据失败:', error);
        this.$message.error(error.response?.data?.message || '获取数据失败');
        this.handleEmptyResult();
      } finally {
        this.loading = false;
      }
    },

    // 修改跳转方法
    goToCourse(row) {
      if (!row.courseName) {
        this.$message.error('未找到课程信息');
        return;
      }

      // 切换到课程教学页面
      this.$parent.handleMenuSelect('/dashboard');
      
      // 使用 setTimeout 确保 Dashboard 组件已经加载
      setTimeout(() => {
        // 通过 EventBus 发送课程选择事件，使用课程名称
        EventBus.$emit('selectCourse', {
          courseName: row.courseName,
          type: 'video'
        });
      }, 100);
    },

    // 获取搜索类型标签
    getSearchTypeLabel() {
      const typeMap = {
        homeworkName: '作业',
        courseName: '课程',
        teachName: '老师'
      };
      return typeMap[this.searchType] || '数据';
    },

    // 处理空结果
    handleEmptyResult() {
      this.drawingData = [];
      this.originalData = [];
      this.total = 0;
      this.emptyText = '暂无数据';
    },
  },
  created() {
    this.fetchDrawingData(); // 组件创建时获取数据
  },
  watch: {
    searchQuery(newVal) {
      // 当搜索框清空时，恢复原始数据
      if (!newVal.trim()) {
        this.drawingData = [...this.originalData];
        this.total = this.originalData.length;
        this.emptyText = '暂无数据';
      }
    },
    selectedNav(newVal) {
      console.log('导航变化:', newVal);
    },
    currentMaterial(newVal) {
      console.log('材质变化:', newVal);
    }
  }
};
</script>

<style scoped>
.drawing-container {
  display: flex;
  height: 100vh;
  
}
.el-container {
  flex: 1;
  display: flex;
}
.el-aside {
  overflow: hidden;
}
.el-main {
  overflow: auto;
}
.preview-img {
  width: 100px;
  height: 100px;
}
.sidebar-menu {
  width: 100%;
  height: 100vh;
}
.search-container {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #fff;
  padding: 15px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

/* 添加课程名称链接样式 */
.course-button {
  padding: 0;
  font-size: 14px;
}

.course-button:hover {
  text-decoration: underline;
}

/* 添加表格相关样式 */
.el-table {
  background-color: #fff;
  border-radius: 4px;
  /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); */
}

/* 调整预览图样式 */
.preview-img {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 4px;
  background: #f6fafd;
  border: 1px solid #f0f2f7;
  box-shadow: 0 1px 6px 0 rgba(46,162,250,0.06);
}

.preview-img:hover {
  transform: scale(1.1);
  cursor: pointer;
}

/* 调整课程按钮样式 */
.course-button {
  padding: 0;
  font-size: 14px;
  color: #409EFF;
}

.course-button:hover {
  color: #66b1ff;
  text-decoration: underline;
}

/* 调整表格内容垂直对齐 */
::v-deep .el-table td {
  padding: 12px 0;
}

/* 调整表头样式 */
::v-deep .el-table th {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: bold;
  padding: 12px 0;
}

/* 调整表格hover效果 */
::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #f5f7fa;
}

/* 确保表格在大屏幕上有合适的间距 */
.drawing-content {
  padding: 20px;
  max-width: 1600px;
  margin: 0 auto;
}

/* 调整操作按钮样式 */
.el-button--small {
  padding: 8px 15px;
}

/* 添加搜索框样式 */
.el-input {
  max-width: 300px;
}

/* 添加日期选择器样式 */
.el-date-picker {
  max-width: 320px;
}

/* 添加选择器样式 */
.el-select {
  max-width: 120px;
}

/* 添加新样式 */
.parameters-content {
  height: 100%;
  overflow-y: auto;
}
.material-detail {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.material-header {
  text-align: center;
  margin-bottom: 30px;
}

.material-header h2 {
  font-size: 24px;
  color: #303133;
  margin-bottom: 10px;
}

.material-description {
  color: #606266;
  font-size: 14px;
}

.material-overview {
  margin-bottom: 40px;
}

.material-image {
  width: 100%;
  height: 300px;
  overflow: hidden;
  border-radius: 8px;
}

.material-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.material-info {
  padding: 20px;
}

.material-info h3 {
  margin-bottom: 15px;
  color: #303133;
}

.material-info ul {
  list-style: none;
  padding: 0;
}

.material-info li {
  margin: 10px 0;
  padding-left: 20px;
  position: relative;
}

.material-info li:before {
  content: "•";
  color: #409EFF;
  position: absolute;
  left: 0;
}

.material-tips {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #EBEEF5;
}

.parameters-section {
  margin: 40px 0;
}

.parameters-section h3 {
  margin-bottom: 20px;
}

.param-name {
  display: flex;
  align-items: center;
  gap: 8px;
}

.examples-section {
  margin-top: 40px;
}

.example-card {
  margin-bottom: 20px;
  transition: transform 0.3s;
}

.example-card:hover {
  transform: translateY(-5px);
}

.example-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.example-info {
  padding: 15px;
}

.example-info h4 {
  margin: 0 0 10px 0;
  font-size: 16px;
}

.example-info p {
  font-size: 14px;
  color: #606266;
  margin: 0;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .material-overview .el-col {
    width: 100%;
  }
  
  .material-image {
    height: 200px;
    margin-bottom: 20px;
  }
}

.material-header {
  position: relative;
  padding-top: 20px;
}

.no-data {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

/* 添加过渡动画 */
.parameters-content {
  animation: fade-in 0.3s ease-in-out;
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.diagram-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 28px 22px;
  padding: 10px 8px 0 8px;
}
.diagram-card {
  position: relative;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 12px 0 rgba(46,162,250,0.08);
  padding: 22px 18px 18px 18px;
  display: flex;
  flex-direction: column;
  min-height: 160px;
}
.diagram-id {
  position: absolute;
  left: 18px;
  top: 12px;
  font-size: 15px;
  color: #8a97a8;
  font-weight: 500;
}
.diagram-card-main {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 18px;
  margin-top: 30px;
}
.diagram-img {
  width: 140px;
  height: 140px;
  object-fit: contain;
  border-radius: 8px;
  background: #f6fafd;
  border: 1px solid #f0f2f7;
  box-shadow: 0 1px 6px 0 rgba(46,162,250,0.06);
}
.diagram-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  justify-content: center;
  min-width: 0;
}
.diagram-title {
  font-size: 17px;
  font-weight: 500;
  color: #222;
  margin-bottom: 6px;
  margin-top: 0;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.diagram-meta {
  font-size: 14px;
  color: #666;
  margin-bottom: 2px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.diagram-link {
  font-size: 14px;
  color: #2EA2FA;
  padding: 0;
}
.diagram-link:hover {
  color: #1976d2;
  text-decoration: underline;
}
.diagram-card-footer {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}
.diagram-make-btn {
  font-size: 15px;
  border-radius: 10px;
  padding: 15px;
  background: #2EA2FA;
  color: #fff;
  border: none;
  width: 90%;
}
@media (max-width: 1280px) {
  .diagram-card-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 18px;
  }
}
@media (max-width: 900px) {
  .diagram-card-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
}

.diagram-aside {
  background: #eaf6fe !important;
  border-radius: 16px 0 0 16px;
  min-height: 100vh;
  box-shadow: 0 2px 12px 0 rgba(46,162,250,0.04);
  padding: 0 0 0 0;
}
.sidebar-menu {
  width: 100%;
  height: 100vh;
  background: #eaf6fe !important;
  border: none;
  padding-top: 18px;
}
.sidebar-title {
  font-size: 16px;
  font-weight: 600;
  color: #222;
  margin-left: 2px;
}
.sidebar-svg-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  vertical-align: middle;
  display: inline-block;
}
.el-menu-item {
  border-radius: 8px !important;
  margin: 0 6px 6px 6px !important;
  padding: 0 12px !important;
  font-size: 15px !important;
  height: 38px !important;
  display: flex;
  align-items: center;
}
.el-menu-item.is-active {
  background: #fff !important;
  color: #2EA2FA !important;
  font-weight: 600;
}
.el-submenu__title {
  font-size: 15px !important;
  color: #222 !important;
  font-weight: 500;
  border-radius: 8px;
  margin: 0 6px;
  padding: 0 12px;
  height: 38px;
}
.el-menu--inline {
  background: #eaf6fe !important;
}
@media (max-width: 900px) {
  .diagram-aside {
    min-width: 100px;
    border-radius: 0;
    padding: 0;
  }
  .sidebar-menu {
    padding-top: 8px;
  }
}

.sidebar-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
